import { render, staticRenderFns } from "./Estrategias.vue?vue&type=template&id=6c642c62&scoped=true&"
import script from "./Estrategias.vue?vue&type=script&lang=js&"
export * from "./Estrategias.vue?vue&type=script&lang=js&"
import style0 from "./Estrategias.vue?vue&type=style&index=0&id=6c642c62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c642c62",
  null
  
)

export default component.exports